export default "__VITE_ASSET__DQW2d72___"